import React, { useRef } from "react";
import { bool, func } from "prop-types";
import { Trans, useTranslation } from "@lib/i18n";
import { useDispatch } from "react-redux";

import Typography from "@components/shared/Typography";
import Modal from "@components/shared/Modal";
import { Button } from "@components/shared/Button";
import { toggleIsScrappageSelectedAction } from "@redux/actions/dealActions";
import { scrappageSelectChangeEvent } from "@gtm/events/homepage";
import gtm from "@gtm/core";

const ScrappageDetailsModal = ({
  isOpen,
  isScrappageSelected,
  onClose,
  closeScrappageModal,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const modalLastElement = useRef(null);

  const scrappageBonusLink = t("price.scrappageBonusLink");

  const toggleScrappageCloseModal = label => () => {
    gtm.fire(
      scrappageSelectChangeEvent({
        isScrappage: isScrappageSelected ? "no" : "yes",
        label: label,
      })
    );
    dispatch(toggleIsScrappageSelectedAction());

    onClose();
  };

  const closeModalAndFireGTM = label => () => {
    gtm.fire(
      scrappageSelectChangeEvent({
        isScrappage: isScrappageSelected ? "yes" : "no",
        label: label,
      })
    );

    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      withCloseIcon
      lastElement={modalLastElement}
      ariaLabel={t("price.modalScrappage.heading")}
      onClose={closeScrappageModal}
    >
      <div className="flex flex-col gap-4 pr-4">
        <Typography className="text-primaryDark text-xl font-semibold uppercase">
          {t("price.modalScrappage.heading")}
        </Typography>
        <Typography className="text-sm">
          <Trans i18nKey="price.modalScrappage.mainInfo">
            <a
              className="text-primaryOrange underline cursor-pointer"
              href={scrappageBonusLink}
              target="_blank"
              rel="noopener noreferrer"
            />
          </Trans>
        </Typography>
        <Typography className="font-semibold text-center text-primaryDark">
          {t("price.modalScrappage.bonusInfo")}
        </Typography>
        <div className="flex flex-col flex-wrap justify-center gap-4 pb-2 smallMobile:flex-row">
          <Button
            variant="secondary"
            onClick={
              isScrappageSelected
                ? toggleScrappageCloseModal(t("price.modalScrappage.buttonNo"))
                : closeModalAndFireGTM(t("price.modalScrappage.buttonNo"))
            }
          >
            {t("price.modalScrappage.buttonNo")}
          </Button>
          <Button
            ref={modalLastElement}
            variant="primary"
            onClick={
              isScrappageSelected
                ? closeModalAndFireGTM(t("price.modalScrappage.buttonYes"))
                : toggleScrappageCloseModal(t("price.modalScrappage.buttonYes"))
            }
          >
            {t("price.modalScrappage.buttonYes")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ScrappageDetailsModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  closeScrappageModal: func.isRequired,
  isScrappageSelected: bool,
};

export default ScrappageDetailsModal;
